import styled, { css } from 'styled-components'

type ContainerProps = {
  equalHeightTabs: boolean
}

export const TabsContainer = styled.div<ContainerProps>`
  .tab-content {
    display: grid;
  }

  .tab-content > div {
    grid-row: 1;
    grid-column: 1;
  }

  ${({ equalHeightTabs }) =>
    !equalHeightTabs &&
    css`
      .tab-content > div[aria-hidden='true'] {
        height: 0;
        overflow: hidden;
      }
    `};
`

export const TabPanel = styled.div.attrs<{ isActive: boolean }>(({ isActive }) => ({
  'aria-hidden': !isActive,
  ...((!isActive && { inert: '' }) as object),
}))<{ isActive: boolean }>`
  visibility: ${(props) => (props.isActive ? 'visible' : 'hidden')};
  width: 100%;
`
